import React from 'react';
import { makeStyles } from '@material-ui/core';

import IconButton from 'ha/ui/next/IconButton';
import SwipeableDrawer from 'ha/ui/next/SwipeableDrawer';
import Slide from 'ha/ui/next/Slide';

import MenuIcon from 'streamline-icons/navigation-menu-bold.svg';
import CloseIcon from 'streamline-icons/close-bold.svg';

import AppBarMobile from './AppBarMobile';
import { MobileMenuType } from '../types';
import MobileMainMenu from '../containers/MobileMainMenu';
import MobilePaymentMenu from '../containers/MobilePaymentMenu';

const useStyles = makeStyles(theme => ({
  darkBlueLight: {
    color: theme.palette.grey[500],
  },
  darkBlueMain: {
    color: theme.palette.grey[700],
  },
}));

interface Props {
  currentMenu: MobileMenuType;
  isDrawerOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
}

export const NavBarMobile: React.FC<Props> = ({
  currentMenu,
  isDrawerOpen,
  openDrawer,
  closeDrawer,
}) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <AppBarMobile>
        <div className={classes.darkBlueLight}>
          <IconButton onClick={openDrawer} size="small">
            <MenuIcon fontSize="small" />
          </IconButton>
        </div>
      </AppBarMobile>
      <SwipeableDrawer
        anchor="right"
        open={isDrawerOpen}
        onOpen={openDrawer}
        onClose={closeDrawer}
        hideBackdrop
        disableBackdropTransition
        fullWidth
      >
        <AppBarMobile>
          <div className={classes.darkBlueLight}>
            <IconButton
              onClick={closeDrawer}
              size="small"
              data-test-locator="NavBar Close Button"
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </div>
        </AppBarMobile>
        <Slide
          unmountOnExit
          direction="right"
          in={currentMenu === MobileMenuType.main}
          exit={false}
        >
          <div className={classes.darkBlueMain}>
            <MobileMainMenu />
          </div>
        </Slide>
        <Slide
          unmountOnExit
          direction="left"
          in={currentMenu === MobileMenuType.payment}
          exit={false}
        >
          <div className={classes.darkBlueMain}>
            <MobilePaymentMenu />
          </div>
        </Slide>
      </SwipeableDrawer>
    </React.Fragment>
  );
};

export default NavBarMobile;
